import axios from 'axios';
import { message } from 'antd';
import config from '../config';

const request = axios.create({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 优先使用管理员token，如果没有则使用普通用户token
    const adminToken = localStorage.getItem('admin_token');
    const userToken = localStorage.getItem('token');
    
    const token = adminToken || userToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 对于blob类型的响应（如文件下载），返回完整的response对象
    if (response.config.responseType === 'blob') {
      return response;
    }
    return response.data;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message.error('认证失败，请重新登录');
          // 清除本地存储的token
          localStorage.removeItem('token');
          // 重定向到登录页面
          window.location.href = '/login';
          break;
        case 403:
          message.error('没有权限访问');
          break;
        case 404:
          message.error('请求的资源不存在');
          break;
        case 500:
          message.error('服务器错误');
          break;
        default:
          message.error('请求失败');
      }
    } else {
      message.error('网络错误，请检查网络连接');
    }
    return Promise.reject(error);
  }
);

export default request; 